/**
 * Sidebar Component
 * Fixed left navigation with logo and menu items
 */

export class Sidebar {
  constructor(container) {
    this.container = container;
    this.currentRoute = 'dashboard';
  }

  render() {
    this.container.innerHTML = `
      <div class="sidebar-header">
        <a href="#/" class="sidebar-logo">
          <img src="/logo-clinica.jpg" alt="Clínica Daher" onerror="this.style.display='none'">
          <div>
            <h2 class="sidebar-title">Fluxo de Caixa</h2>
            <p class="sidebar-subtitle">Clínica Daher</p>
          </div>
        </a>
      </div>

      <nav class="sidebar-nav">
        <div class="nav-section">
          <h3 class="nav-section-title">Principal</h3>
          <ul class="nav-list">
            <li class="nav-item">
              <a href="#/" class="nav-link" data-route="dashboard">
                <span class="nav-icon">📊</span>
                <span>Dashboard</span>
              </a>
            </li>
            <li class="nav-item">
              <a href="#/transactions" class="nav-link" data-route="transactions">
                <span class="nav-icon">💳</span>
                <span>Lançamentos</span>
              </a>
            </li>
            <li class="nav-item">
              <a href="#/reports" class="nav-link" data-route="reports">
                <span class="nav-icon">📈</span>
                <span>Relatórios</span>
              </a>
            </li>
          </ul>
        </div>

        <div class="nav-section">
          <h3 class="nav-section-title">Dados</h3>
          <ul class="nav-list">
            <li class="nav-item">
              <a href="#/import-export" class="nav-link" data-route="import-export">
                <span class="nav-icon">📁</span>
                <span>Importar/Exportar</span>
              </a>
            </li>
          </ul>
        </div>

        <div class="nav-section">
          <h3 class="nav-section-title">Sistema</h3>
          <ul class="nav-list">
            <li class="nav-item">
              <a href="#/settings" class="nav-link" data-route="settings">
                <span class="nav-icon">⚙️</span>
                <span>Configurações</span>
              </a>
            </li>
          </ul>
        </div>
      </nav>
    `;

    this.attachEventListeners();
  }

  attachEventListeners() {
    const links = this.container.querySelectorAll('.nav-link');
    links.forEach(link => {
      link.addEventListener('click', (e) => {
        // Links com href funcionam naturalmente com hash routing
        // Apenas atualizamos o estado visual
        setTimeout(() => {
          this.setActiveRoute(link.dataset.route);
        }, 10);
      });
    });
  }

  setActiveRoute(route) {
    this.currentRoute = route;

    // Remove active class from all links
    const links = this.container.querySelectorAll('.nav-link');
    links.forEach(link => link.classList.remove('active'));

    // Add active class to current route
    const activeLink = this.container.querySelector(`[data-route="${route}"]`);
    if (activeLink) {
      activeLink.classList.add('active');
    }
  }

  updateRoute(route) {
    this.setActiveRoute(route);
  }
}
